<script>
import Card from '@/components/common/Card.vue';
import ColumnChart from './ColumnChart.vue';

export default {
  name: 'CampaignsRatioCharts',
  components: { Card, ColumnChart },
  props: {
    charts: {
      type: Array,
      default: () => [],
    },
    campaigns: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    xAxisLabels() {
      return this.campaigns?.map(campaign => campaign.name);
    },
  },
};
</script>

<template>
  <div v-loading class="campaigns-ratio-charts">
    <Card
      v-if="loading"
      v-loading="true"
      class="campaigns-ratio-charts__loading"
    />

    <template v-else>
      <Card
        v-for="chart in charts"
        :key="chart.title"
        v-loading="loading"
        class="campaigns-ratio-charts__chart"
      >
        <div class="campaigns-ratio-charts__chart-title">
          <div class="text-small">{{ chart.title }}</div>
          <div>{{ chart.overall }}%</div>
        </div>
        <ColumnChart
          :values="Object.values(chart.campaignsData)"
          :x-axis="xAxisLabels"
        />
      </Card>
    </template>
  </div>
</template>

<style lang="scss">
.campaigns-ratio-charts {
  display: flex;
  gap: 0.5rem;

  @include breakpoint(medium down) {
    flex-wrap: wrap;
  }

  &__loading {
    height: 395px;
    width: 100%;
  }

  &__chart {
    width: 100%;
    // flex-shrink: 0;
    flex-grow: 1;
    display: flex;
    justify-content: center;
  }

  &__chart-title {
    display: flex;
    justify-content: space-between;
    font-size: 1.3rem;
  }
}
</style>
